/**
 * Sectores de "reserva de citas" para los que los servicios del simulador se
 * persisten por lead (contact_id) en DynamoDB a través del endpoint
 * reutilizado `/ventas/lead-carta*` con `kind=service`.
 *
 * Cuando el LeadEditModal entra al simulador con un `contactId` cuyo sector
 * está en este set, los servicios se cargan desde/guardan en la tabla
 * `c_lead_demo_carta` en lugar de la tabla global `p_services` de la empresa.
 */
export const APPOINTMENT_SECTORS = new Set([
  "barberia",
  "peluquerias",
  "estetica",
  "canina",
  "tatuajes",
  "fisioterapia",
  "osteopatia",
  "psicologia",
  "lavadero",
  "salud",
  "spa",
  "consultoria",
  "despacho_abogados",
  "otro",
]);

export const isAppointmentSector = (sector) =>
  typeof sector === "string" && APPOINTMENT_SECTORS.has(sector);
